import z from 'zod';

// TODO: Enable required fields again once all env vars are ensured to be provided in each environment
// const requiredIfApp = isHybridApp ? z.string() : z.string().optional();
// const requiredIfProd = import.meta.env.PROD && !isHybridApp ? z.string() : z.string().optional();

const requiredIfApp = z.string().optional();
const requiredIfProd = z.string().optional();

export const environmentSchema = z.object({
    VITE_SENTRY_DSN_JS: requiredIfProd,
    VITE_SENTRY_ENVIRONMENT: requiredIfProd,
    VITE_SENTRY_TRACING_SAMPLE_RATE: z.coerce.number().default(0.1),
    VITE_BASE_URL: requiredIfApp,
    VITE_APP_VERSION: requiredIfProd,
    VITE_DEV_BASE_URL: requiredIfProd,
    // Authentication
    VITE_OAUTH_AZURE_ID: requiredIfProd,
    VITE_OAUTH_GOOGLE_ID: requiredIfProd,
    // Featurebase
    VITE_FEATUREBASE_ORG: z.string().optional(),

    VITE_MATOMO_URL: z.string().optional(),
    VITE_MATOMO_SITE_ID: z.coerce.number().optional(),

    // App
    VITE_OAUTH_GOOGLE_IOS_ID: requiredIfApp,
    VITE_DEV_ERROR_HANDLING: z.enum(['throw', 'alert', 'log']).default('log'),
});

export type Environment = z.infer<typeof environmentSchema>;
